import { Encoder, Decoder } from "cbor-x"

const CBOR_OPTIONS = {
  useRecords: true,
  structuredClone: false,
  mapsAsObjects: false,
  tagUint8Array: true,
}

const encBundled = new Encoder({ ...CBOR_OPTIONS, bundleStrings: true })
const encPlain = new Encoder({ ...CBOR_OPTIONS, bundleStrings: false })
const decBundled = new Decoder({ ...CBOR_OPTIONS, bundleStrings: true })
const decPlain = new Decoder({ ...CBOR_OPTIONS, bundleStrings: false })

// bundleStrings workaround (cbor-x bug #121):
//   All strings <4 chars → cbor-x appends 0xf7 0xf7 without bundle header.
//   Detected O(1) via last two bytes. Fall back to plain encoder/decoder.
// https://github.com/kriszyp/cbor-x/issues/121
function isBundleStringsBug(bytes: Uint8Array): boolean {
  return bytes.length >= 2 && bytes[bytes.length - 2] === 0xf7 && bytes[bytes.length - 1] === 0xf7
}

/** Object → CBOR bytes */
export function serialize(object: unknown): Uint8Array {
  const bytes = encBundled.encode(object)
  return isBundleStringsBug(bytes) ? encPlain.encode(object) : bytes
}

/** Identity passthrough — binary-fetch already decoded before tRPC sees it */
export function deserialize(input: unknown): unknown {
  return input
}

/** CBOR bytes → tRPC envelope. Called by binary-fetch on the client. */
export function prepareEnvelopeAtArrival(bytes: Uint8Array) {
  const decoded = isBundleStringsBug(bytes) ? decPlain.decode(bytes) : decBundled.decode(bytes)
  return { result: { type: "data" as const, data: decoded } }
}
